// Définir l'URL de base de l'API
export const ApiUrl = process.env.REACT_APP_HOST_API || "https://apitrack.spyteam.fr/api/v1/";

// Fonction pour générer des headers selon le type de contenu
export const header = (type = "json") => {
  const token = localStorage.getItem("access_token");

  const headers = {
    json: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }), // Ajoute le token si dispo
    },
    image: {
      "Content-Type": "multipart/form-data",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  };

  return {
    headers: headers[type] || headers.json,
  };
};
